import type { LocationPagedResult, LocationsApi } from '../../models';

export const normalizeLocations = (result: LocationPagedResult | null): LocationsApi => {
  if (result === null) {
    return { data: [], total: 0 };
  }

  return {
    data: (result.items ?? []).map((item) => ({ ...item, id: String(item.locationKey) })),
    total: result.totalCount,
  };
};
